import { render } from "./MedicoList.vue?vue&type=template&id=37115a8f&scoped=true"
import script from "./MedicoList.vue?vue&type=script&lang=js"
export * from "./MedicoList.vue?vue&type=script&lang=js"

import "./MedicoList.vue?vue&type=style&index=0&id=37115a8f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37115a8f"]])

export default __exports__